import { seriesAndFrameToViewIndex } from "../../utilities/viewUtils";
import { CONFIGURATION_LOADED } from "../actions/configurationActions";
import { SET_ACTIVE_SERIES_AND_FRAME, SET_ACTIVE_VIEW_INDEX } from "../actions/viewActions";
import ViewState from "../stateTypes/viewState";

const initialState: ViewState = {
    activeViewIndex: null,
    imageSeries: [],
};

const viewReducer = (state: ViewState = initialState, action: any = {}) => {
    switch (action.type) {
        case SET_ACTIVE_VIEW_INDEX: {
            return {
                ...state,
                activeViewIndex: action.activeViewIndex,
            };
        }
        case SET_ACTIVE_SERIES_AND_FRAME: {
            return {
                ...state,
                activeViewIndex: seriesAndFrameToViewIndex(
                    state.imageSeries,
                    action.activeSeriesId,
                    action.activeFrame
                ),
            };
        }
        case CONFIGURATION_LOADED:
            return {
                ...state,
                imageSeries: action.imageSeries,
                activeViewIndex: seriesAndFrameToViewIndex(
                    action.imageSeries,
                    action.activeSeriesId,
                    action.activeFrame
                ),
            };
        default:
            return state;
    }
};

export default viewReducer;
